
export const SET_FORMS = 'SET_FORMS'

export function setProvideFeedbackForm (forms) {
  return dispatch => {
    dispatch({
      type: SET_FORMS,
      data: forms
    })
  }
}
